/* eslint-disable react-hooks/exhaustive-deps */
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createFamilyPostRequest, createFamilyPutRequest, mapFamilyRow } from './FormFields/familyFormFields';
import { createMultiTabComponentContent, createMultiTabComponentTabs } from './FormFields/multiTabFormFields';
import {
  deleteFamilyMember,
  deleteFamilyPet,
  getFamilyMembers,
  getFamilyPets,
  postEmployeeInfo,
  postFamilyMember,
  postFamilyPet,
  updateEmployeeInfo,
  updateFamilyMember,
  updateFamilyMembersState,
  updateFamilyPet,
  updateFamilyPetsState
} from '../../store/actions/authorizations.actions';
import { showToast } from 'modules/layout/layout.actions';
import { useEmployeeHandler } from './Handlers/useEmployeeHandler';
import { useFamilyHandler } from './Handlers/useFamilyHandler';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { createFamilyPetPostRequest, createFamilyPetPutRequest, mapPetRow } from './FormFields/petFormFields';
import { usePetHandler } from './Handlers/usePetHandler';
import MultiTabCard from 'modules/common/multiTabCard/multiTabCard.component';

const orderList = family => {
  if (!Array.isArray(family)) return [];

  const priorityMap = {
    EE: 1,
    Spouse: 2,
    Partner: 3,
    Elderly: 4,
    Child: 5
  };

  return [...family].sort((a, b) => {
    const priorityA = priorityMap[a.relationship] || 6;
    const priorityB = priorityMap[b.relationship] || 6;

    return priorityA - priorityB;
  });
};

const EmployeeCard = props => {
  const { clientInfo, employee, family, id, vendors, familyPets, enumerations, isReadOnly = false } = props;

  const employeeHandler = useEmployeeHandler(props);
  const familyHandler = useFamilyHandler(props);
  const petHandler = usePetHandler(props);
  let familyList = orderList(family);

  useEffect(async () => {
    // let eeExist = Array.isArray(family) ? family.find(s => s.relationship === RelationshipOptions[0]) : true;
    // if (!eeExist) {
    //   let eeName = details?.summary?.transfereeName ? details?.summary?.transfereeName.split(' ') : ['', ''];
    //   let postRequest = {
    //     authorizationId: id,
    //     familyMemberId: 0,
    //     firstName: eeName[0],
    //     lastName: eeName[1],
    //     relationship: RelationshipOptions[0],
    //     isPrimaryContact: true
    //   };
    //   await handleCrudOperation(familyHandler.handleCreateFamilyMember, postRequest);
    // }
  }, []);

  useEffect(() => {
    familyList = orderList(family);
  }, [family]);

  const [isLoading, setIsLoading] = useState(false);

  const handleEmployeeFormSubmission = async (tab, values) => {
    try {
      setIsLoading(true);
      values.authorizationId = id;
      return await employeeHandler.createOrUpdateEmployee(!(employee && employee.length !== 0), values);
    } catch (error) {
      console.error('Error submitting employee form:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCrudOperation = async (operation, ...args) => {
    try {
      setIsLoading(true);
      const response = await operation(...args);
      return response;
    } catch (error) {
      console.error('Error during CRUD operation:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateFamilyRow = async (originalRow, newRow) => {
    // Match on id rather than row index: the table pins the transferee first, so its row order differs from `family`.
    const originalMember = family.find(member => member.familyMemberId === originalRow.original.familyMemberId);
    if (!originalMember) return false;

    const updatedValues = createFamilyPutRequest(originalMember, newRow, id);
    const resp = await handleCrudOperation(familyHandler.handleUpdateFamilyMember, updatedValues);
    if (!resp) return false;

    return { hasContent: true, content: mapFamilyRow(updatedValues) };
  };

  const createFamilyRow = async newRow => {
    return await handleCrudOperation(familyHandler.handleCreateFamilyMember, createFamilyPostRequest(newRow, id));
  };

  const deleteFamilyRow = async rowToDelete => {
    const response = await handleCrudOperation(familyHandler.handleDeleteFamilyMember, id, rowToDelete.original.familyMemberId);
    if (response) {
      props.updateFamilyMembersState(family.filter(fam => fam.familyMemberId !== rowToDelete.original.familyMemberId));
    }
    return true;
  };

  const updatePetRow = async (originalRow, newRow) => {
    newRow.petsId = originalRow.original.petsId;
    newRow.rowVersion = originalRow.original.rowVersion;

    const originalPet = familyPets.find(pet => pet.petsId === originalRow.original.petsId);
    if (!originalPet) return false;

    const updatedValues = createFamilyPetPutRequest(originalPet, newRow, id);
    const resp = await handleCrudOperation(petHandler.handleUpdatePet, updatedValues);
    if (!resp) return false;

    return { hasContent: true, content: mapPetRow(updatedValues) };
  };

  const createPetRow = async newRow => {
    return await handleCrudOperation(petHandler.handleCreatePet, createFamilyPetPostRequest(newRow, id));
  };

  const deletePetRow = async rowToDelete => {
    const response = await handleCrudOperation(petHandler.handleDeletePet, id, rowToDelete.original.petsId);
    if (response) {
      props.updateFamilyPetsState(familyPets.filter(pet => pet.petsId !== rowToDelete.original.petsId));
    }
    return true;
  };

  const cardContents = createMultiTabComponentContent(
    clientInfo,
    handleEmployeeFormSubmission,
    isLoading,
    familyList,
    updateFamilyRow,
    createFamilyRow,
    deleteFamilyRow,
    vendors,
    familyPets,
    updatePetRow,
    createPetRow,
    deletePetRow,
    enumerations
  );

  const readonlyContents = isReadOnly ? cardContents.map(content => ({ ...content, hideEdit: true, hideAdd: true })) : cardContents;

  return (
    <MultiTabCard
      tabs={createMultiTabComponentTabs()}
      contents={readonlyContents}
      showBasicTable={true}
    />
  );
};

EmployeeCard.propTypes = {
  clientInfo: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  family: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  postFamilyMember: PropTypes.func.isRequired,
  updateFamilyMember: PropTypes.func.isRequired,
  getFamilyMembers: PropTypes.func.isRequired,
  deleteFamilyMember: PropTypes.func.isRequired,
  postEmployeeInfo: PropTypes.func.isRequired,
  updateEmployeeInfo: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired,
  getFamilyPets: PropTypes.func.isRequired,
  postFamilyPet: PropTypes.func.isRequired,
  updateFamilyPet: PropTypes.func.isRequired,
  deleteFamilyPet: PropTypes.func.isRequired,
  updateFamilyPetsState: PropTypes.func.isRequired,
  vendors: PropTypes.array.isRequired,
  familyPets: PropTypes.array.isRequired
};

const mapStateToProps = state => {
  const { allEnums } = state.enumerations;
  
  return {
    enumerations: allEnums
  };
};


export default compose(
  connect(mapStateToProps, {
    postFamilyMember,
    updateFamilyMember,
    getFamilyMembers,
    deleteFamilyMember,
    postEmployeeInfo,
    updateEmployeeInfo,
    updateFamilyMembersState,
    showToast,
    getFamilyPets,
    postFamilyPet,
    updateFamilyPet,
    deleteFamilyPet,
    updateFamilyPetsState
  })
)(EmployeeCard);
